/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tcType: NonNullable<unknown> }} Input_Tc_Set_Button_Aria_LabelInputs */

const en_input_tc_set_button_aria_label = /** @type {(inputs: Input_Tc_Set_Button_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set timecode for ${i?.tcType}`)
};

const fr_input_tc_set_button_aria_label = /** @type {(inputs: Input_Tc_Set_Button_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Définir le timecode pour ${i?.tcType}`)
};

const de_input_tc_set_button_aria_label = /** @type {(inputs: Input_Tc_Set_Button_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Setze Zeitcode für ${i?.tcType}`)
};

const it_input_tc_set_button_aria_label = /** @type {(inputs: Input_Tc_Set_Button_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Imposta il codice temporale per ${i?.tcType}`)
};

const ru_input_tc_set_button_aria_label = /** @type {(inputs: Input_Tc_Set_Button_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Установите временной код для ${i?.tcType}`)
};

const es_input_tc_set_button_aria_label = /** @type {(inputs: Input_Tc_Set_Button_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Establecer código de tiempo para ${i?.tcType}`)
};

const zh_cn2_input_tc_set_button_aria_label = /** @type {(inputs: Input_Tc_Set_Button_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`设置 ${i?.tcType} 的时间码`)
};

const ja_input_tc_set_button_aria_label = /** @type {(inputs: Input_Tc_Set_Button_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tcType} のタイムコードを設定する`)
};

const hi_input_tc_set_button_aria_label = /** @type {(inputs: Input_Tc_Set_Button_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tcType} के लिए टाइमकोड सेट करें`)
};

const pt_pt2_input_tc_set_button_aria_label = /** @type {(inputs: Input_Tc_Set_Button_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Defina o código de tempo para ${i?.tcType}`)
};

/**
* | output |
* | --- |
* | "Set timecode for {tcType}" |
*
* @param {Input_Tc_Set_Button_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_tc_set_button_aria_label = /** @type {((inputs: Input_Tc_Set_Button_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Tc_Set_Button_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_tc_set_button_aria_label(inputs)
	if (locale === "de") return de_input_tc_set_button_aria_label(inputs)
	if (locale === "it") return it_input_tc_set_button_aria_label(inputs)
	if (locale === "ru") return ru_input_tc_set_button_aria_label(inputs)
	if (locale === "es") return es_input_tc_set_button_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_input_tc_set_button_aria_label(inputs)
	if (locale === "ja") return ja_input_tc_set_button_aria_label(inputs)
	if (locale === "hi") return hi_input_tc_set_button_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_input_tc_set_button_aria_label(inputs)
	return en_input_tc_set_button_aria_label(inputs)
});